/**
 * --------------------------------------------
 * KANYOS DropdownMenu.js
 * License ANZAS
 * --------------------------------------------
 */

import $ from 'jquery'

/**
 * Constants
 * ====================================================
 */

const NAME = 'DropdownMenu'
const DATA_KEY = 'lte.dropdownmenu'
// const EVENT_KEY = `.${DATA_KEY}`
const JQUERY_NO_CONFLICT = $.fn[NAME]

const CLASS_NAME_DROPDOWN_MENU = 'dropdown-menu'
const CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item'
const CLASS_NAME_LOADING_DIVIDER = 'dropdown-divider'
const CLASS_NAME_DISABLED = 'disabled text-gray'
const CLASS_NAME_LOADING_TRIGGER = 'loading-trigger'

// const EVENT_CHANGED = `changed${EVENT_KEY}`

// const SELECTOR_DATA_TOGGLE = '[data-widget="dropdown-list"]'

const Default = {
  dataSource: undefined,
  baseUrl: '',
  dropdownMenuClass: `${CLASS_NAME_DROPDOWN_MENU} dropdown-menu-left`,
  onChange(item) {
    return item
  }
}

/**
 * Class Definition
 * ====================================================
 */

class DropdownMenu {
  constructor(element, config) {
    this._config = config
    this._element = element

    this._init()
  }

  // Private

  _init() {
    if (this._config.dataSource === undefined ||
      this._config.dataSource.MenuItems === undefined ||
      this._config.dataSource.MenuItems.length === 0) {
      return
    }

    const $dropdownMenu = $(`<div class="${this._config.dropdownMenuClass}"/>`)

    for (let i = 0; i < this._config.dataSource.MenuItems.length; i++) {
      const menuItem = this._config.dataSource.MenuItems[i]

      if (!menuItem.Visible) {
        continue
      }

      let dropdownItemClass = !menuItem.Enabled ?
        `${CLASS_NAME_DROPDOWN_ITEM} ${CLASS_NAME_DISABLED}` :
        CLASS_NAME_DROPDOWN_ITEM

      if (menuItem.Target === '_self') {
        dropdownItemClass = `${dropdownItemClass} ${CLASS_NAME_LOADING_TRIGGER}`
      }

      if (i > 0) {
        $dropdownMenu.append($(`<div class="${CLASS_NAME_LOADING_DIVIDER}"></div>`))
      }

      $dropdownMenu.append($(`<a href="${this._config.baseUrl}${menuItem.Url}" target="${menuItem.Target}" class="${dropdownItemClass}">`)
        .append(`<i class="${menuItem.NaviIconClass} mr-2"></i>`)
        .append(menuItem.Title))
    }

    this._element.after($dropdownMenu)
  }

  // Static

  static _jQueryInterface(config) {
    return this.each(function () {
      let data = $(this).data(DATA_KEY)

      if (!data) {
        data = $(this).data()
      }

      const _options = $.extend({}, Default, typeof config === 'object' ? config : data)
      const plugin = new DropdownMenu($(this), _options)

      $(this).data(DATA_KEY, typeof config === 'object' ? config : data)

      if (config === 'init') {
        plugin[config]()
      }
    })
  }
}

/**
 * Data API
 * ====================================================
 */

// $(window).on('load', () => {
//   DropdownMenu._jQueryInterface.call($(SELECTOR_DATA_TOGGLE))
// })

/**
 * jQuery API
 * ====================================================
 */

$.fn[NAME] = DropdownMenu._jQueryInterface
$.fn[NAME].Constructor = DropdownMenu
$.fn[NAME].noConflict = function () {
  $.fn[NAME] = JQUERY_NO_CONFLICT
  return DropdownMenu._jQueryInterface
}

export default DropdownMenu
